import React from 'react'

import Header from '../../../components/header'
import DoctorCard from '../../../components/doctor-card'

import * as S from './styles'

import IProps from './props'

const RecentContacts = ({ recentContacts }: IProps) => (
  <S.Container>
    <Header title="Contatos recentes" />
    <S.Content>
      {recentContacts.map((doctor: any) => (
        <DoctorCard
          key={doctor.id}
          name={doctor.name}
          location={doctor.location}
          linkChat={doctor.linkChat}
          linkProfile={doctor.linkProfile}
          hasNewMessage={doctor.hasNewMessage}
        />
      ))}
    </S.Content>
  </S.Container>
)

export default RecentContacts
